import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export default function InviteAcceptance() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const invitationToken = searchParams.get("invitationToken");
    const token = searchParams.get("token");
    const resolvedToken = invitationToken || token;

    if (resolvedToken) {
      window.location.replace(`/setup-invitation?token=${encodeURIComponent(resolvedToken)}`);
      return;
    }

    window.location.replace("/sign-in");
  }, [searchParams]);

  return (
    <div style={{ textAlign: "center", padding: "50px" }}>
      <p>Opening invitation...</p>
    </div>
  );
}
